import Colors from '@/v2/domains/Activities/constants/colors';
import ActivityTypeGlyph from '@/v2/domains/Activities/components/ActivityTypeGlyph/ActivityTypeGlyph';

import { Container, IconBadge } from './ActivityTypeIcon.styled';

export default function ActivityTypeIcon({ type, size = 32, count, ...props }) {
  return (
    <IconBadge count={count}>
      <Container $color={Colors[type]} {...props}>
        <ActivityTypeGlyph type={type} size={size / 2} color="white" />
      </Container>
    </IconBadge>
  );
}
